export const accountNames = [
  ['0012', 'LICENCIJE'],
  ['0020', 'RAČUNALNI PROGRAMI'],
  ['0032', 'ULAGANJA - PRISTUPNA CESTA JAKOVLJE'],
  ['0033', 'ULAGANJA U TUĐU MATERIJALNU IMOVINU ILICA 1A'],
  ['0091', 'IV PATENTI, LICENCIJE'],
  ['0092', 'IV RAČUNALNIH PROGRAMA'],
  ['00932', 'IV ULAGANJA PRISTUPNA CESTA'],
  ['00933', 'IV ULAGANJA U TUĐU MATERIJALNU IMOVINU'],
  ['0100', 'ZEMLJIŠTE'],
  ['0101', 'ZEMLJIŠTE-JAKOVLJE'],
  ['02020', 'GRAĐEVINSKI OBJEKT HALA DICMO'],
  ['02021', 'GRAĐEVINSKI OBJEKT TVORNICA JAKOVLJE'],
  ['02100', 'STROJEVI  SCZ JANKOMIR'],
  ['02101', 'STROJEVI  SCZ POGON PVC GRANULAT'],
  ['02102', 'STROJEVI TVORNICA JAKOVLJE'],
  ['02103', 'OSTALA OPREMA PROCESNA AMBALAŽA JANKOMIR'],
  ['02104', 'OSTALA OPREMA - PROCESNA AMBALAŽA JAKOVLJE'],
  ['02110', 'TEHNIČKA POSTROJENJA SPREMNICI,MOTORI I SL. JANKOMIR'],
  ['02111', 'TEHNIČKA POSTROJENJA, SPREMNICI,MOTORI I SL. JAKOVLJE'],
  ['02121', 'KOMPJUTORSKA OPREMA SCZ JANKOMIR'],
  ['02122', 'KOMPJUTORSKA OPREMA  JAKOVLJE'],
  ['02123', 'ELEKTRONIČKA  OPREMA  SCZ JANKOMIR'],
  ['02124', 'ELEKTRONIČKA  OPREMA JAKOVLJE'],
  ['02127', 'ELEKTRONIČKA OPREMA DICMO'],
  ['02128', 'KOMPJUTERSKA OPREMA ILICA'],
  ['02130', 'MJERNA OPREMA  JANKOMIR'],
  ['02131', 'MJERNA OPREMA  JAKOVLJE'],
  ['02132', 'ELEKTRONIČKA OPREMA ILICA'],
  ['02140', 'OPREMA ZA GRIJANJE,VENTILACIJU,RASH.UREĐAJI JANKOMIR'],
  ['02141', 'OPREMA ZA GRIJANJE VENTILACIJU, RASH.UREĐAJI JAKOVLJE'],
  ['02180', 'LABORATORIJSKA OP.JANKOMIR'],
  ['02181', 'LABORATORIJSKA OP.JAKOVLJE'],
  ['02191', 'OSTALA OPREMA JAKOVLJE'],
  ['02192', 'OSTALA OPREMA ILICA'],
  ['02201', 'ALATI - JANKOMIR'],
  ['02202', 'ALATI - JAKOVLJE'],
  ['02210', 'POGONSKI NAMJEŠTAJ SCZ JANKOMIR'],
  ['02211', 'POGONSKI NAMJEŠTAJ JAKOVLJE'],
  ['02220', 'UREDSKI NAMJEŠTAJ SCZ JANKOMIR'],
  ['02221', 'UREDSKI NAMJEŠTAJ JAKOVLJE'],
  ['02222', 'NAMJEŠTAJ UREDSKI'],
  ['02223', 'UREDSKI NAMJEŠTAJ ILICA'],
  ['02230', 'OSOBNI AUTOMOBILI'],
  ['02231', 'DOSTAVNA VOZILA'],
  ['02232', 'OSTALA TRANSPORTNA VOZILA - VILIČARI'],
  ['02240', 'TELEFONSKE CENTRALE SCZ JANKOMIR'],
  ['02241', 'TELEFONSKE CENTRALE JAKOVLJE'],
  ['02500', 'INVESTICIJE U TIJEKU HALA DICMO'],
  ['02502', 'INVESTICIJE U TIJEKU TVORNICA JAKOVLJE'],
  ['02504', 'INVESTICIJE U TIJEKU - RAČUNALNI PROGRAM AX DYNAMICS'],
  ['02505', 'OPREMA U PRIPREMI - INFORATIČKA OPREMA'],
  ['02507', 'INVESTICIJE U TIJEKU- MONTAŽNO SKLADIŠTE  JAKOVLJE'],
  ['02508', 'ZEMLJIŠTE U PRIPREMI-Šušnjevi'],
  ['0270', 'VRIJEDNOSNO USKLAĐENJE OPREME'],
  ['02820', 'DJELA LIKOVNIH UMJETNIKA - SLIKE SCZ JANKOMIR'],
  ['029000', 'IV HALA DICMO'],
  ['029001', 'IV TVORNICA JAKOVLJE'],
  ['029013', 'IV PR.AMB. JAKOVLJE'],
  ['029101', 'IV STROJEVI JANKOMIR'],
  ['029102', 'IV STROJEVI JAKOVLJE'],
  ['029103', 'IV PR.AMB.JANKOMIR'],
  ['029110', 'IV TEH.POSTROJENJA JANKOMIR'],
  ['029111', 'IV TEH. POST. JAKOVLJE'],
  ['029121', 'IV KOMP.OPREMA JANKOMIR'],
  ['029122', 'IV KOMP.OP. JAKOVLJE'],
  ['029123', 'IV ELEKT. OP.JANKOMIR'],
  ['029124', 'IV ELEKT. OP.JAKOVLJE'],
  ['029127', 'IV ELEKTRONIČKA OPREMA DICMO'],
  ['029128', 'IV KOMPJUTERSKA OPREMA ILICA'],
  ['029130', 'IV MJERNA OP.JANKOMIR'],
  ['029131', 'IV MJERNA OP. JAKOVLJE'],
  ['029132', 'IV ELEKTRONIČKA OPREMA ILICA'],
  ['029140', 'IV OP. GRIJ., VEN.,RAS.UR. JANKOMIR'],
  ['029141', 'IV OP. GRI.,VENT.,RAS. JAKOVLJE'],
  ['029180', 'IV LAB. OP. JANKOMIR'],
  ['029181', 'IV LAB OP.  JAKOVLJE'],
  ['029191', 'IV OSTALE OPREME JAKOVLJE'],
  ['029192', 'IV OSTALE OPREME ILICA'],
  ['029201', 'ISP.VR. ALATI JANKOMIR'],
  ['029202', 'ISP.VR. ALATI JAKOVLJE'],
  ['029210', 'ISP.VR. POG.I NAMJ. JANKOMIR'],
  ['029211', 'ISP.VR. POG. NAMJ. JAKOVLJE'],
  ['029220', 'IV  UREDSKI NAMJ.'],
  ['029221', 'IV  UREDSKI NAMJ. JANMKOMIR'],
  ['029222', 'IV  UREDSKI NAMJ. JAKOVLJE'],
  ['029223', 'IV UREDSKI NAMJEŠTAJ ILICA'],
  ['029225', 'IS.VR. DOSTAVNA VOZILA'],
  ['029232', 'ISP.VR. OSOBNI AUTOMOBILI'],
  ['029233', 'SIP.VR. OSTALA TR.SREDSTVA VILIČARI  JANKOMIR'],
  ['029240', 'ISP.VR. TELEFONSKE CENTRALE SCZ JANKOMIR'],
  ['029241', 'IV TEL.CENT. JAKOVLJE'],
  ['0402', 'OSNIVAČKI ULOG EC D.O.O.'],
  ['04029', 'VRIJEDNOSNO USKL.-ULAGANJA U POVEZANA DRŠ.'],
  ['0403', 'Poslovni udjeli-Domaći proizvođači kabela d.o.o.'],
  ['052', 'POTRAŽ.PO OSNOVI PROD.NA KRED.U EU'],
  ['05319', 'DISKONT DUGOROČNIH POTRAŽIVANJA OD KUPACA'],
  ['0532', 'ODGOĐENA POTRAŽIVANJA OD KUPACA IZ PREDSTEČ. NAGODBE'],
  ['055', 'Dugoročna potraživanja Eurocable d.o.o.'],
  ['0551', 'Potraživanje za kamatu od povezanih (Croatia Banka)'],
  ['0559', 'DISKONT DUGOROČNIH POTRAŽIVANJA PREMA POVEZANIMA'],
  ['0580', 'POTRAŽIVANJA ZA DANE POZAJMICE'],
  ['10010', 'ŽIRO RAČUN 2500009-1501131638 ZONSKI KN'],
  ['10013', 'ŽIRO RAČUN 2484008-1105445357 RBA'],
  ['10014', 'ŽIRO RAČUN 2485003-1100290994 CROATIA BANKA'],
  ['1002', 'ŽIRO R.2500009-1101007918'],
  ['1006', 'ŽIRO RAČUN PBZ 2340009-1110319229'],
  ['1007', 'ŽIRO RAČUN SPLITSKA BANKA 2330003-1100392064'],
  ['1009', 'ŽIRO RAČUN PRIJELAZNI KONTO'],
  ['10092', 'Ž.R. PRIJENOS NA ISTOG SUDIONIKA KUNE'],
  ['10093', 'Ž.R. PRIJENOS NA ISTOG SUDIONIKA  EUR'],
  ['10094', 'Ž.R. PRIJENOS NA ISTOG SUDIONIKA USD'],
  ['1020', 'GLAVNA BLAGAJNA'],
  ['1021', 'DEVIZNA BLAGAJNA'],
  ['1030', 'DEVIZNI RAČUN-7001 978 EUR  REDOVNI'],
  ['10306', 'DEVIZI ŽIRO RAČUN PBZ REDOVNI'],
  ['10307', 'DEVIZNI Ž.R. RBA REDOVNI EUR'],
  ['10309', 'DEVIZNI Ž.R. RBA REDOVNI USD'],
  ['1031', 'DEVIZNI RAČUN-71014 978 EUR ZONA'],
  ['10311', 'DEVIZNI RAČUN UBS AG EUR'],
  ['10312', 'DEVIZNI RAČUN UBS AG CHF'],
  ['10313', 'DEVIZNI RAČUN RBA 977 BAM'],
  ['10315', 'DEVIZNI Ž.R. CROATIA BANKA EUR'],
  ['1032', 'DEVIZNI RAČUN-7001 840 USD REDOVNI'],
  ['1033', 'DEVIZNI RAČUN -71014 840 USD ZONA'],
  ['1036', 'DEVIZNI RAČUN-HVB-7001-840-REDOVNI DOLARI'],
  ['10399', 'DEVIZNI RAČUN PBZ 1510362591 USD'],
  ['1200', 'KUPCI U ZEMLJI'],
  ['1202', 'KUPCI U ZEMLJI - POTRAŽIVANJA MEINHART'],
  ['1210', 'POTRAŽIVANJA OD INO KUPACA'],
  ['1211', 'POTRAŽIVANJA KUPCI IZ EU'],
  ['1215', 'POTRAŽIVANJA INO FAKTORING'],
  ['1219', 'POTRAŽIVANJA OD KUPACA USLUGE-INOZEMNI NEPOVEZANI'],
  ['1220', 'KUPCI-POVEZANA DRUŠTVA U ZEMLJI'],
  ['12240', 'Potraživanje za kamate - povezani (Croatia Banka)'],
  ['1270', 'POTRAŽIVANJA STEČENA CESIJOM, ASIG. I PREUZIMANJEM DUGA'],
  ['12901', 'ISPRAVAK VRIJEDNOSTI  POTRAŽIVANJA PREMA POVEZANIMA'],
  ['1300', 'DANI AVANSI DOBAVLJAČIMA U ZEMLJI'],
  ['1301', 'DANI AVANSI DOBAVLJAČIMA U INOZEMSTVU'],
  ['1305', 'DANI PREDUJMOVI DOBAVLJAČIMA U ZEMLJI(NETO)'],
  ['14001', 'PRETPOREZ 13%'],
  ['1401', 'PRETPOREZ  25 %'],
  ['1404', 'PREPLATA PO RAZLICI POREZA I PRETPOREZA'],
  ['1407', 'PRETPOREZ PO ULAZNIM RAČUNIMA 5%'],
  ['14082', 'PRETPOREZ IZ PREDUJMOVA 25%'],
  ['14091', 'PRETPOREZ PO UL. RAČUNIMA ZBOG PREN. POREZNE OBVEZE 25%'],
  ['14092', 'PRETPOREZ OD POREZNIH OBV. BEZ SJEDIŠTA U RH 25%'],
  ['1412', 'PRETPOREZ OD STJECANJA DOBARA IZ EU 25%'],
  ['1422', 'PRETPOREZ OD PRIMLJENIH USLUGA IZ EU 25%'],
  ['1497', 'PRETPOREZ UVOZ 25%'],
  ['1498', 'PRETPOREZ R-2 - 25%'],
  ['1570', 'DANI DEPOZITI I JAMČEVINE'],
  ['1571', 'DANI DEPOZITI EUROLEASING ŠKODA ZG 6907 GD'],
  ['1575', 'DANI DEPOZITI EUROLEASING CITROEN ZG 4108 GD'],
  ['1576', 'DANI DEPOZITI EUROLEASING ŠKODA ZG 4103 GD'],
  ['1577', 'DANI DEPOZITI EUROLEASING ŠKODA ZG 4104 GD'],
  ['1578', 'DANI DEPOZITI - PROSTOR ILICA'],
  ['1579', 'DANI DEPOZITI MERCEDES BENZ LEASING'],
  ['1610', 'POTRAŽIVANJA ZA VIŠE PLAĆENI PREDUJAM DOBITI'],
  ['1611', 'POTRAŽIVANJA ZA PREDUJAM POREZ NA DOHODAK'],
  ['1612', 'POTRAŽIVANJA ZA PREPLAĆENE DOPRINOSE HGK'],
  ['1614', 'POTRAŽIVANJA ZA PL.PREDUJMOVE POREZ NA DOBIT'],
  ['1630', 'AKONTACIJE ZA SLUŽBENA PUTOVANJA'],
  ['16310', 'POTRAŽIVANJA OD RADNIKA-E.TOLJ'],
  ['16313', 'OSTALA POTRAŽIVANJA OD ZAPOSLENIKA'],
  ['16315', 'POZAJMICE J.MAJSTROVIĆ'],
  ['1634', 'POZAJMICE IVAN LULIĆ'],
  ['1638', 'POZAJMNICE TOMICA ERJAVEC'],
  ['1661', 'POTRAŽIVANJA  HZZO - BOLOVANJA NA TERET FONDA'],
  ['1662', 'POTRAŽIVANJA MINISTARSTVO ZAŠTITE  OKOLIŠA I PRIRODE'],
  ['1681', 'POTRAŽIVANJA ZA KAMATU POZAJMICE -ZAPOSLENICI'],
  ['1900', 'UNAPRIJED PLAĆENI TR.-OPER. LEASING MERCEDES ZG 2171 DK'],
  ['1901', 'UNAP. PL. TR.- OSIGURANJE'],
  ['1902', 'UNAPRIJED PLAĆENI TR.-OPER. LEASING CITROEN ZG 4108 GD'],
  ['1903', 'UNAPRIJED PLAĆENI TROŠKOVI - OSTALO'],
  ['1906', 'UNAPRIJED PLAĆENI TR. - OSIG. AUTOMOBILA'],
  ['1907', 'UNAPRIJED PLAĆENI TROŠKOVI CESTARINA - ENC UREĐAJ'],
  ['1908', 'UNAPRIJED PLAĆENI TR.-OPER. LEASING ŠKODA ZG 4104 GD'],
  ['1909', 'UNAPRIJED PLAĆENI TR.-OPER. LEASING ŠKODA ZG 4103 GD'],
  ['19090', 'UNAPRIJED PLAĆENI TR.-OPER. LEASING ŠKODA ZG 6907 GD'],
  ['2200', 'DOBAVLJAČI U ZEMLJI'],
  ['2204', 'DOBAVLJAČI- KARTICE I GOTOVINA'],
  ['2209', 'Obveze prema dobavljačima prijelazni konto'],
  ['2211', 'DOBAVLJAČI INO EU'],
  ['2212', 'DOBALJAČI INO TREĆE ZEMLJE'],
  ['2240', 'OBVEZE PREMA DRŽAVI,JAV.TIJEL. I DRUŠTVIMA U VL. DRŽAV'],
  ['2241', 'OBVEZE PREMA FINANCIJSKIM INSTITUCIJAMA'],
  ['2242', 'OBVEZE PREMA FINANCIJSKIM INSITUCIJAMA U DEVIZAMA'],
  ['2243', 'OBVEZE PREMA NEOSIGURANIM INOZEMNIM VJEROVNICIMA-EU'],
  ['22431', 'OBVEZE PREMA NEOSIG. INOZEMNIM VJEROVNICIMA-EU U KN'],
  ['2244', 'OBVEZE PREMA POVEZ. NEOSIG. INOZEMNIM VJEROVNICIMA- EU'],
  ['2245', 'OBVEZE PREMA NEOSIG. INOZEMNIM VJEROVNICIMA- TREĆE ZEM'],
  ['2247', 'OBVEZE PREMA NEOSIGURANIM DOMAĆIM VJEROVNICIMA'],
  ['2248', 'OBVEZE PREMA NEOSIG.VJEROV. ZA RED. KAMATE do 19.05.'],
  ['22481', 'OBVEZE PREMA NEOSIG.VJEROV. ZA ZATEZ. KAMATE do 19.05.'],
  ['22482', 'OBVEZE PREMA NEOSIG.VJEROV. ZA TROŠK.POST. do 19.05.'],
  ['2300', 'PRIMLJENI AVANSI OD KUPACA U ZEMLJI'],
  ['2302', 'PRIMLJENI AVANSI OD KUPACA NETO'],
  ['2304', 'PRIMLJENI AVANSI OD INO KUPACA-NEPOVEZANA'],
  ['2401', 'OBVEZE ZA PDV PO ISPORUKAMA DOBARA'],
  ['2405', 'POIREZ 25% TEREĆENJA ZA USLUGE INO DOBAVLJAČI'],
  ['24091', 'OBVEZA PDV-a PO ISPORUKAMA IZ PRENESENE POR. OBVEZE 25%'],
  ['2412', 'OBVEZA ZA PDV ZA STJECANJE DOBARA IZ EU 25%'],
  ['2422', 'OBVEZE ZA PDV ZA PRIMLJENE USLUGE IZ EU 25%'],
  ['2431', 'OBVEZA OD POREZ. OBV. BEZ SJEDIŠTA U RH 25%'],
  ['2580', 'POZAJMICE'],
  ['2590', 'OBVEZE ZA KAMATE FIZIČKIM OSOBAMA'],
  ['2610', 'OBVEZE ZA POREZ IZ DOBITI'],
  ['2630', 'OBVEZA ZA PRIJEVOZ NA POSAO I SA POSLA ZAPOSLENICIMA'],
  ['2634', 'OBVEZE PREMA RADNICIMA ZA OTPREMNINE'],
  ['2641', 'DOPRINOS ZA ZDRAVSTV.OSIG.NA BRUTO PLAĆE'],
  ['2642', 'DOPRINOS ZA ZAPOŠLJAVANJE NA BRUTO PLAĆE'],
  ['2643', 'POSEBNI DOP.ZA ZDRAVSTVENO OSIG.-NEZGODA'],
  ['26432', 'DOPRINOS ZA ZAP.OSOBA S INVALIDITETOM'],
  ['2652', 'DOPRINOS ZA ŠUME'],
  ['2653', 'ČLANARINA HGK'],
  ['2691', 'OBVEZE S TEMELJA SLUŽBENIH PUTOVANJA'],
  ['2692', 'OBVEZA S TEMELJA  INO SLUŽBENIH PUTOVANJA'],
  ['2700', 'OBVEZE ZA BRUTTO PLAĆE'],
  ['2710', 'OBVEZE ZA NETO PLAĆE'],
  ['2712', 'ODBICI IZ NETO PLAĆE'],
  ['2720', 'DOPRINOS ZA MIO IZ PLAĆA'],
  ['2723', 'DOPRINOS ZA MIO II STUP'],
  ['2730', 'OBVEZE IZ POREZA NA DOHODAK'],
  ['2740', 'OBVEZE ZA PRIREZ NA POREZ IZ DOHODTKA'],
  ['2762', 'OBVEZA ZA III. STUP MIROVINSKOG OSIGURANJA'],
  ['2900', 'UKALKULIRANI TROŠKOVI OBRAČUNSKOG RAZDOBLJA'],
  ['29027', 'NAKNADE PO ŽIRO RAČUNU UBS AG'],
  ['3003', 'KUPOVNA CIJENA SIROVINA TV2 JAKOVLJE'],
  ['3004', 'KUPOVNA CIJENA SIROVINA PP TV2 JAKOVLJE'],
  ['3102', 'SIROVINE U SKLADIŠTU TV2 JAKOVLJE'],
  ['3103', 'SIROVINE U SKLADIŠTU TV2 PP JAKOVLJE'],
  ['3105', 'KOREKCIJA OBRAČUNA JAKOVLJE'],
  ['3121', 'MATERIJAL U DORADI PP TV 2'],
  ['3141', 'DORAĐENI MATERIJAL PP TV2'],
  ['3510', 'SITAN INVENTAR U UPOTREBI'],
  ['35121', 'RADNA ODJEĆA - ZONA'],
  ['35123', 'RADNA ODJEĆA DICMO'],
  ['35124', 'RADNA ODJEĆA JAKOVLJE'],
  ['3513', 'SITAN INVENTAR U UPOTREBI - JAKOVLJE'],
  ['3521', 'REZERVNI DIJELOVI JAKOVLJE'],
  ['3530', 'AUTOGUME U UPORABI ZA OSTALA VOZILA'],
  ['3531', 'AUTO GUME U UPORABI OSOBNI AUTOMOBILI'],
  ['3570', 'ISPR,VRIJED.SIT.INVENTARA'],
  ['3571', 'IV RAD. ODJEĆA I OBUĆA'],
  ['3572', 'ISPRAVAK VR. AUTOGUMA U UPORABI'],
  ['3573', 'ISPRAVAK VRIJEDNOSTI AUTO GUME OSOBNI AUT.'],
  ['3574', 'ISPRAVAK VRIJEDNOSTI RADNA ODJEĆA JAKOVLJE'],
  ['3575', 'ISPRAVAK VRIJEDNOSTI SITNOG INV. JAKOVLJE'],
  ['3900', 'OBRAČUN NABAVNE VRIJEDNOSTI MEĐUSKLADIŠNICA'],
  ['400001', 'UTROŠENE SIROVINE I MATERIJAL JAKOVLJE'],
  ['400002', 'UREDSKI MATERIJAL - JAKOVLJE'],
  ['400003', 'IZDAVANJE NUS I REPRA - JAKOVLJE'],
  ['40005', 'UTROŠEN MATERIJAL - JAKOVLJE'],
  ['40008', 'VODA ZA PIĆE JAKOVLJE'],
  ['40009', 'UTROŠENI MATERIJAL VAN NORMATIVA-JAKOVLJE'],
  ['4001', 'UREDSKI MATERIJAL'],
  ['40016', 'UTROŠEN MATERIJAL - UREDSKI PROSTOR ILICA'],
  ['4002', 'UTROŠENI OSTALI MATERIJAL'],
  ['4008', 'VODA ZA PIĆE'],
  ['4011', 'GORIVO-BERLINGO'],
  ['40112', 'GORIVO-MERCEDES'],
  ['40113', 'GORIVO-SMART'],
  ['40122', 'UTROŠENO GORIVO - PLIN JAKOVLJE'],
  ['40124', 'GORIVO-CITROEN'],
  ['40125', 'PLIN-VILIČAR JAKOVLJE'],
  ['40127', 'GORIVO VILIČAR-JAKOVLJE'],
  ['40128', 'GORIVO ŠKODA'],
  ['4014', 'UTROŠENA ELEKTRIČNA ENERGIJA - DICMO'],
  ['4015', 'UTROŠENA ELEKTRIČNA ENERGIJA JAKOVLJE'],
  ['4050', 'OTPIS SITNOG INVENTARA'],
  ['4051', 'TROŠKOVI ZA RADNU ODJEĆU I OBUĆU'],
  ['4052', 'OTPIS AUTOGUMA U UPORABI'],
  ['4054', 'OTPIS TROŠKOVI RADNA ODJEĆA JAKOVLJE'],
  ['4055', 'OTPIS SITNOG INVENTARA JAKOVLJE'],
  ['4100', 'POŠTARINA'],
  ['4101', 'TELEFONSKI TROŠKOVI'],
  ['4102', 'PRIJEVOZNE USLUGE - PRODAJA'],
  ['4103', 'PRIJEVOZNE USLUGE OSTALE'],
  ['4106', 'PRIJEVOZNE USLUGE - ULAZ REPRA'],
  ['4107', 'CESTARINE,TUNELARINE, MOSTARINE I sl.'],
  ['4110', 'USLUGE STUDENT SERVISA'],
  ['4120', 'USLUGE TEKUĆEG ODRŽAVANJA'],
  ['41201', 'USLUGA ODRŽAVANJA OS. VOZILA - PLAĆA U NARAVI'],
  ['41202', 'USLUGE ODRŽAVANJA DI I SI - JAKOVLJE'],
  ['41205', 'USLUGE ČIŠĆENJA PREMA UGOVORU'],
  ['4121', 'USLUGA ODRZAVANJA OSOBNIH VOZILA'],
  ['4122', 'TROŠAK INVESTICIJSKOG ODRŽAVANJA'],
  ['4124', 'USLUGE ODRŽAVANJA VILIČARA'],
  ['4125', 'USLUGE ODRŽAVANJA ELEKTRONIČKE    OPREME'],
  ['41250', 'USLUGE ODRŽAVANJA ELEKTRONIČKE OPREME-JAKOVLJE'],
  ['41260', 'USLUGE ODRŽAVANJE MEHANIKE-JAKOVLJE'],
  ['4127', 'USLUGE ODRŽAVANJA MJERNE OPREME'],
  ['41270', 'USLUGE ODRŽAVANJA MJERNE OPREME JAKOVLJE'],
  ['4129', 'USLUGE ODRŽAVANJA DOSTAVNIH VOZILA'],
  ['41404', 'NAJAM OPREME - OSTALO'],
  ['41405', 'NAJAMNINA MERCEDES'],
  ['41416', 'NAJAMNINA ZA VILIČAR - JAKOVLJE'],
  ['41417', 'NAJAM OPREME OSTALO JAKOVLJE'],
  ['41418', 'NAJAMNINA LEASING CITROEN'],
  ['41420', 'NAJAMNINA VOZILA- ŠKODA'],
  ['41422', 'NAJAM POSLOVNOG PROSTORA ILICA'],
  ['41423', 'TROŠKOVI NAJMA - ARHIVSKA DOKUMENTACIJA'],
  ['4151', 'TROŠKOVI OGLAŠAVANJA'],
  ['4170', 'KOMUNALNA  NAKNADE I DOPRINOSI'],
  ['41701', 'ODVOZ SMEĆA DICMO'],
  ['41702', 'VODA I ODVODNJA JAKOVLJE'],
  ['41703', 'VODOPRIVREDNI DOPIRNOS DICMO'],
  ['41704', 'VODNI DOPRINOS JAKOVLJE'],
  ['41705', 'KOMUNALNI DOPRINOS JAKOVLJE'],
  ['41706', 'ODVOZ SMEĆA JAKOVLJE'],
  ['4173', 'VODA I ODVODNJA DICMO'],
  ['4175', 'DERATIZACIJA I DEZINSEKCIJA'],
  ['4178', 'DIMNJAČARSKE USLUGE'],
  ['4190', 'OSTALE USLUGE'],
  ['419004', 'TROŠAK ČUVANJA OBJEKTA - JAKOVLJE'],
  ['4196', 'ŠPEDITERSKE USLUGE'],
  ['41993', 'TROŠKOVI SREDIŠNJA DEPOZITARNA AGENCIJA'],
  ['4300', 'AMORTIZACIJA'],
  ['4400', 'DNEVNICE NA SLUŽBENOM PUTU U ZEMLJI'],
  ['44011', 'TROŠKOVI UPOR.PRIV.AUTA U SL.SVRHE-LOKO'],
  ['4402', 'DNEVNICE NA SLUŽBENOM PUTU U INOZEMSTVU'],
  ['4403', 'TROŠKOVI PRIJEVOZA NA SLUŽBENOM PUTU'],
  ['4404', 'TROŠKOVI NOĆENJA NA SLUŽBENOM PUTU'],
  ['4406', 'TROŠ. PRIJEVOZA ZAPOSLENIH SA POSLA NA POSAO'],
  ['4408', 'OSTALI TROŠKOVI NA SL.PUTU-CESTARINE'],
  ['4409', 'TROŠKOVI PARKIRANJA'],
  ['44091', 'TROŠAK ZDRAVSTVENIH PREGLEDA ZAPOSLENIH'],
  ['4410', 'INTELEKT.USLUGE, RAČ.-FINANC.USLUGE'],
  ['44101', 'INTELEKTUALNE USLUGE - REVIZIJA'],
  ['4411', 'INTEL.USLUGE-ODVJETNIČKE,JAVNOBILJEŽNIČKE'],
  ['4412', 'INTELEKT.USLUGE- SOFTWARE,OSTALO'],
  ['4413', 'INTELEKT.USLUGE-PRIJEVODI'],
  ['4420', 'REPREZENTACIJA'],
  ['44301', 'PREMIJE OSIGURANJE IMOVINE - JAKOVLJE'],
  ['44302', 'PREMIJA OSIGURANJA ODGOVORNOST ZA NEISP. PROIZVOD'],
  ['4431', 'PREMIJE OSIGURANJA-AUTOMOBILI'],
  ['4433', 'PREMIJA OSIGURANJA - NEZGODA'],
  ['4435', 'PREMIJE OSIGURANJA-OSTALO'],
  ['4441', 'TROŠKOVI ZAŠTITE OKOLIŠA - JAKOVLJE'],
  ['4458', 'POREZ NA CESTOVNA MOTORNA VOZILA'],
  ['4462', 'DOPRINOS ZA ŠUME'],
  ['4463', 'ČLANARINA HGK'],
  ['4466', 'VODOPRIVREDNE NAKNADE - DOPRINOSI'],
  ['4470', 'NAKNADE ZA BANKARSKE USLUGE I PROVIZIJE'],
  ['44701', 'ČLANARINE PBZ AMERICAN EXPRESS'],
  ['44705', 'NAKNADE ZA BANKARSKE USLUGE PBZ d.d.'],
  ['44706', 'NAKNADE ZA BANKARSKE USLUGE SPLITSKA BANKA'],
  ['44716', 'NAKNADE ZA PLATNI PROMET RBA'],
  ['4472', 'ČLANARINE UDRUGAMA,DRUŠTVIMA,SAVEZIMA'],
  ['44723', 'NAKNADE DRUGIH INO BANAKA'],
  ['44727', 'NAKNADE PO ŽIRO RAČUNU UBS AG'],
  ['44728', 'USLUGE PLATNOG PROMETA CROATIA BANKA'],
  ['4480', 'OTPREMNINE ZAPOSLENICIMA'],
  ['4481', 'OTPREMNINE ZBOG POSLOVNO I OSOBNO UVJETOVANIH OTKAZA'],
  ['4485', 'BOŽIĆNICA,USKRSNICA,REGRES ZA GO I SL.'],
  ['4488', 'POTPORE ZBOG BOLESTI, SMRTI,EL.NEP. I SL.'],
  ['4490', 'TROŠKOVI STRUČNOG OBRAZOVANJA'],
  ['4491', 'TROŠKOVI ZA PRIRUČNIKE,ČASOPISE,STRUČ.LITER.'],
  ['44922', 'TR.SEMINARA,SAVJETOVANJA'],
  ['44923', 'PREPLATA NA BURZOVNO IZVJEŠĆE (LME)'],
  ['4493', 'NAKNADA ZA ATESTE I LICENCE'],
  ['4494', 'TROŠKOVI REGISTRACIJE AUTOMOBILA'],
  ['4496', 'TROŠKOVI CARINJENJA UVOZ'],
  ['4497', 'TROŠKOVI OPOMENA,'],
  ['44971', 'TROŠKOVI PO NAGODBAMA I SUDSKIM PROCESIMA'],
  ['4499', 'OSTALI TROŠKOVI'],
  ['4640', 'ADMINISTRATIVNE PRISTOJBE'],
  ['4700', 'NETO PLAĆE'],
  ['4701', 'DOPRINOS ZA MIO IZ PLAĆE'],
  ['4710', 'OBVEZE ZA POREZ IZ DOHOTKA'],
  ['4712', 'PRIREZ NA POREZ IZ DOHOTKA'],
  ['4721', 'DOPRINOS ZA ZDRAVST.OSIG.NA BRUTO PLAĆE'],
  ['4722', 'DOPRINOS ZA ZAPOŠLJAVANJE NA BRUTO PLAĆE'],
  ['4723', 'POSEBNI DOP.ZA ZDRAVSTVENO 0,47%'],
  ['4724', 'DOPR.ZA ZAP.OSOBA S INVALIDITETOM'],
  ['4762', 'NAKNADA ZA ZAPOŠLJAVANJE INVALIDA'],
  ['490001', 'RASPORED TROŠKOVA TVORNICA JAKOVLJE'],
  ['51', 'Predaja modula iz pogona'],
  ['510001', 'PREDAJA MODULA - TVORNICA JAKOVLJE'],
  ['52', 'Zaliha modula'],
  ['520001', 'ZALIHE MODULA TVORNICA JAKOVLJE'],
  ['520002', 'OTPAD MODULA JAKOVLJE'],
  ['53', 'Izdavanje modula u proizvodnju'],
  ['530001', 'IZDAVANJE MODULA U PROIZVODNJU'],
  ['530002', 'OTPAD MODULA JAKOVLJE'],
  ['600001', 'PROIZVODNJA U TIJEKU TVORNICA JAKOVLJE'],
  ['60900', 'ODSTUPANJA OD CIJENA POLUPR.'],
  ['6302', 'SKLADIŠTE NEKURETNIH GOTOVIH PROIZVODA'],
  ['6303', 'SKLADIŠTE GOTOVIH PROIZVODA JAKOVLJE'],
  ['6390', 'ODSTUPANJA OD CIJENA GP'],
  ['6501', 'KUPOVNA CIJENA ROBE OD DOBAVLJAČA - JAKOVLJE'],
  ['6602', 'ZALIHE TRGOVAČKE ROBE JAKOVLJE'],
  ['6710', 'DANI PREDUJMOVI INO DOBAVLJAČIMA'],
  ['6800', 'OSTALA IMOVINA NAMIJENJENA PRODAJI  (INO)'],
  ['7003', 'TPP TV-2 TUZEM-NEPOVEZANA'],
  ['7005', 'KOREKCIJE CIJENE TPP TV-2'],
  ['7009', 'TPP TV-2 NEKURENTNA ZALIHA'],
  ['7013', 'TPP TV-2 INO NEPOVEZANA'],
  ['7103', 'NVPR TV-2 TUZEM-NEPOVEZANA'],
  ['7210', 'ZATEZNE KAMATE'],
  ['72102', 'REDOVNE KAMATE FINANCIJSKI LEASING'],
  ['7218', 'KAMATE PU'],
  ['721940', 'TROSAK FINANCIRANJA - RM'],
  ['7220', 'NEGATIVNE TEČAJNE RAZLIKE'],
  ['72201', 'KAMATE FINANCIJSKE INSTITUCIJE PSN'],
  ['72202', 'KAMATE JTD PSN'],
  ['72203', 'KAMATE FINANCIJSKE INSTITUCIJE-JAMSTVA PSN'],
  ['72211', 'Negativne tečajne razlike-Tesla'],
  ['7225', 'NEGATIVNE TEČAJNE RAZLIKE - KREDITI'],
  ['7228', 'NEG.TEČ. RAZ.- OBVEZE TREĆE ZEMLJE'],
  ['7229', 'NEG. TEČ. RAZ. -POTRAŽIVANJA EU'],
  ['72290', 'NEG. TEČ. RAZ. - OBVEZE EU'],
  ['7301', 'NEOTPISANA VRIJEDNOST PRODANE DUG. IMOVINE'],
  ['7331', 'DOPUŠTENI KALO RASIP LOM'],
  ['7336', 'FINAN.RAZLIKE UTROŠKA MATERIJALA JAKOVLJE'],
  ['7353', 'NAKNADE ŠTETE'],
  ['7370', 'NAKNADNO UTVRĐENI RASHODI IZ PROTEKLIH GOD.'],
  ['73903', 'TROŠKOVI PREFAKTURIRANIH USLUGA NEPOVEZANA DR.'],
  ['73962', 'TEREĆENJA R.M.'],
  ['7503', 'PPP TV-2 TUZEM-NEPOVEZANA'],
  ['7506', 'PRIHODI TV-2 EU - NEPOVEZNA'],
  ['7562', 'PR. S OSN. UP. ZA NAMJENE/PLAĆA U NARAVI'],
  ['7571', 'PR.OD NAJAMNINA - NEPOVEZANA TUZEMNO'],
  ['7574', 'PRIHODI OD NAKNADA ZA NAJAM'],
  ['7603', 'PPR TV-2 TUZEM-NEPOVEZANA'],
  ['7634', 'PRIHOD OD USLUGA PPV INO NEPOVEZANI R.M.'],
  ['7636', 'PRIHODI OD USLUGA PPV U TUZEMSTVU NEPOVEZANI'],
  ['7710', 'PRIHODI OD KAMATE BANKE'],
  ['7712', 'PRIHODI OD KAMATA-POZAJMICE'],
  ['7719', 'DISKONT - fin prihod po osnovi disk LT obveza po PSN'],
  ['7720', 'PRIHODI OD KAMATA POVEZANA DR.'],
  ['7750', 'POZITIVNE TEČAJNE RAZLIKE'],
  ['7754', 'POZITIVNE TEČAJNE RAZLIKE - KREDITI'],
  ['77552', 'POZ.TEČ.RAZ. POV. DRUŠTVA- POTRAŽIVANJA EU'],
  ['7757', 'POZ.TEČ.RAZ. - OBVEZE TREĆE ZEMLJE'],
  ['7758', 'POZ.TEČ.RAZ. - POTRAŽIVANJA EU'],
  ['7759', 'POZ.TEČ.RAZ. - OBVEZE EU'],
  ['7762', 'PRIHODI OD OBUSTAVA RADNIKA'],
  ['7792', 'OSTALI NESPOMENUTI FINANCIJSKI PRIHODI'],
  ['7800', 'PRIHODI OD PRODAJE MAT.I NEMAT.IMOVINE'],
  ['7807', 'PRIHOD OD FINAN.RAZLIKA OBRAČUNA NABAVE- ROBA'],
  ['7812', 'PRIHODI OD PRODAJE SITNOG INVENTARA'],
  ['7841', 'PRIHODI OD PRODAJE OTPADA TV2 JAKOVLJE'],
  ['7843', 'PR.OD PR.AMBALAŽNOG OTPADA (PDV)'],
  ['7850', 'PRIHODI OD NAKNADA ŠTETA OD OSIGURANJA'],
  ['7870', 'PRIHODI IZ PROTEKLIH GODINA'],
  ['78906', 'PR.OD ODOB/TER. INO NEPOVEZANA'],
  ['7891', 'PRIHODI PO USKLAĐENJU'],
  ['78911', 'PRIHODI OD TEREĆENJA - NEPOVEZANA EU'],
  ['78914', 'OSTALI IZVANREDNI PRIHODI'],
  ['9130', 'KAPITAL INOKOSNOG VLASNIKA'],
  ['9200', 'ZAKONSKE REZERVE'],
  ['9210', 'KAPITALNE REZERVE'],
  ['9300', 'ZADRŽANA DOBIT'],
  ['9410', 'GUBITAK IZ PROTEKLIH GODINA'],
  ['9510', 'GUBITAK TEKUĆE GODINE'],
  ['9623', 'FINANCIJSKI LEASING-EUROLEASING d.o.o. UG 10/115/12'],
  ['9701', 'Dugoročne obveze prema dobavljačima PSN'],
  ['97011', 'Dugoročne obveze prema povezanim dobavljačima-EU'],
  ['97019', 'DISKONT OBVEZA PREMA SVIM DOBAVLJACIMA - PSN'],
  ['9702', 'Dugoročne obveze prema JTD PSN'],
  ['97029', 'DISKONT OBVEZA PREMA JTD - PSN'],
  ['9703', 'Dugoročne obveze prema financijskim institucijama PSN'],
  ['97039', 'DISKONT OBVEZA PREMA FIN INST - PSN'],
  ['9704', 'Dugoročne obveze za ukalkuliranu kamatu po Bulletu'],
];
